import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// views
import { SelectWrapper } from 'components/FormElements/Select/views'

export const Header = styled.div`
  position: relative;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.blue500};
  margin-bottom: 20px;

  && {
    svg {
      top: 0;
      right: -12px;
    }
  }
  
`

export const Content = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Disclaimer = styled.p`
  text-align: center;
  font-size: 12px;
  color: ${colors.gray380};
  margin: 12px 0 0;
`

export const TableWrapper = styled.div`
  overflow: auto;
`

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
`

export const TableHeaderCell = styled.div`
  min-width: 200px;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.gray400};
`


export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8px;

  > form:nth-child(odd) {
    background: #f5f5f5;
  }

  > form:nth-child(even) {
    background: #ffffff;
  }
`

export const TableRow = styled.form`
  display: flex;
  position: relative;
  width: 100%;
  min-width: max-content;
  min-height: 64px;
`

export const TableCell = styled.div`
  display: flex;
  width: 200px;
  font-size: 14px;
  color: ${colors.gray900};
  padding: 4px;

  > div {
    width: 100%;
  }

  .MuiFormLabel-root {
    display: none;
  }

  .MuiInputBase-root {
    margin-top: 0;
  }

  .location-select-wrapper {
    margin-top: 0;
  }

  ${SelectWrapper} {
    margin-top: 0;
  }
`

export const SelectionRow = styled.div`
  display: flex;
  align-items: center;
  min-height: 28px;
  margin-bottom: 8px;
`

export const ChipContent = styled.div`
  font-size: 14px;
  display: flex;
  gap: 6px;
  align-items: center;
  color: ${colors.gray900};
`

export const OverlayStack = styled.div`
  position: sticky;
  right: 4px;
  align-self: center;
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
  z-index: 2;
  padding-left: 4px;
  background: transparent;
`

export const BadgeGroup = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const Badge = styled.span<{ variant?: 'ai' | 'filter' }>`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 3px 7px;
  border-radius: 25px;
  height: 24px;
  white-space: nowrap;

  ${({ variant = 'filter' }) =>
    variant === 'ai'
      ? `
    background: #f0ebff;
    color: #6b3fa0;
    border: 1px solid #d6c5f5;
  `
      : `
    background: #e8f4fd;
    color: #1a6fa3;
    border: 1px solid #b3d9f5;
  `}
`
